const prefix: string = 'https://';

const hasHttpsPrefix = (url: string) => url.startsWith(prefix);

export const appendHttpsToUrl = (url: string): string => {
  return hasHttpsPrefix(url) ? url : prefix.concat(url);
};
